import React from "react";

const Mission = () => {
  return (
    <div className="py-10 ">
      <div className="space-y-4 mb-14">
        <p className="text-primary font-semibold text-sm">Nice to meet you</p>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
          <h3 className="col-span-2 lg:text-3xl text-2xl font-bold  lg:w-2/3 w-full">
            Our mission is to increase the safety of your instituition
          </h3>
          <p className="text-accent text-sm">
            Morbi sed imperdiet in ipsum, adipiscing elit dui lectus. Tellus id
            scelerisque est ultricies ultricies. Duis est sit sed leo nisl,
            blandit elit sagittis. Quisque tristique consequat quam sed. Nisl at
            scelerisque amet nulla purus habitasse.
          </p>
        </div>
      </div>
      <div>
        <div className="bg-[#E6FEF2] flex justify-around items-center py-10">
          <div className="text-center ">
            <h2 className="text-primary font-bold lg:text-5xl md:text-3xl text-2xl mb-2">
              400+
            </h2>
            <p className="lg:text-lg md:text-lg  text-green-900 font-semibold">
              Companies
            </p>
          </div>
          <div className="text-center ">
            <h2 className="text-primary font-bold lg:text-5xl md:text-3xl text-2xl mb-2">
              600%
            </h2>
            <p className="lg:text-lg md:text-lg  text-green-900 font-semibold">
              Faster Work
            </p>
          </div>
          <div className="text-center ">
            <h2 className="text-primary font-bold lg:text-5xl md:text-3xl text-2xl mb-2">
              100k
            </h2>
            <p className="lg:text-lg md:text-lg  text-green-900 font-semibold">
              Partners
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
